import Vue from "vue";

export const CustomerEventBus = new Vue();
